import CountAmenityModal
    from "@CheckOrder/features/amenities/features/countAmenity/features/modal/components/CountAmenityModal";
import useDialog from "@Features/dialog/hooks/useDialog";
import EditAmenitiesCta from "@CheckOrder/features/amenities/components/EditAmenitiesCta";
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import useOpenAmenitiesSelectionScreen from "@CheckOrder/features/amenities/hooks/useOpenAmenitiesSelectionScreen";
import SelectedCountAmenityList
    from "@CheckOrder/features/amenities/features/countAmenity/features/list/components/SelectedCountAmenityList";
import {
    PairedSingleAndReturnAmenitiesType
} from "@CheckOrder/features/amenities/types/PairedSingleAndReturnAmenities.type";
import getGroupTranslationAndIcon
    from "@CheckOrder/features/amenities/features/countAmenity/functions/getGroupTranslationAndIcon";
import useHasPreviouslySelectedAmenitiesFromThisGroup
    from "@CheckOrder/features/amenities/features/countAmenity/hooks/useHasPreviouslySelectedAmenitiesFromThisGroup";
import IconTicketAmenityGroup from "@Icons/ticket/amenities/IconTicketAmenityGroup";
import useIsMobile from "@Hooks/selector/useIsMobile";
import useRemoveSelectedAmenities
    from "@CheckOrder/features/amenities/features/countAmenity/hooks/useRemoveSelectedAmenities";
import AddTicketExtra from "@CheckOrder/components/AddTicketExtra";

interface CountAmenityProps {
    pairedAmenityGroups: PairedSingleAndReturnAmenitiesType,
    openErrorModal: () => void,
    groupKey: string,
}

/**
 * Type of AmenityGroup where each amenity is handled by "counter" (+ and - increases count of an amenity)
 */
function CountAmenityGroup({pairedAmenityGroups, openErrorModal, groupKey}: CountAmenityProps) {
    const {icon, translations} = getGroupTranslationAndIcon(pairedAmenityGroups)

    const {
        dialogRef,
        openModal,
        closeModal,
    } = useDialog()

    const {passengerDataUpdating} = useAppSelector((state) => (state.checkOrder))
    const {openAmenities} = useOpenAmenitiesSelectionScreen(groupKey, openModal, passengerDataUpdating)
    const {removeAmenityGroup} = useRemoveSelectedAmenities(pairedAmenityGroups)
    const showEditCta = useHasPreviouslySelectedAmenitiesFromThisGroup(pairedAmenityGroups)

    const isMobile = useIsMobile()

    return (
        <>
            {showEditCta ? (
                <EditAmenitiesCta
                    title={translations.selectedAmenitiesCta}
                    openEditScreen={openAmenities}
                    removeSelectedAmenities={removeAmenityGroup}
                    isUpdating={passengerDataUpdating}
                >
                    <SelectedCountAmenityList
                        openAmenities={openAmenities}
                        pairedAmenityGroups={pairedAmenityGroups}
                    />
                </EditAmenitiesCta>
            ) : (
                <AddTicketExtra
                    title={translations.cta}
                    description={translations.ctaDescription}
                    icon={(
                        <IconTicketAmenityGroup
                            {...icon}
                            width={isMobile ? "24" : "32"}
                            height={isMobile ? "24" : "32"}
                        />
                    )}
                    openSelection={openAmenities}
                    isUpdating={passengerDataUpdating}
                    isCard
                />
            )}
            <CountAmenityModal
                dialogRef={dialogRef}
                pairedAmenityGroups={pairedAmenityGroups}
                translations={translations.modal}
                closeModal={closeModal}
                openErrorModal={openErrorModal}
            />
        </>
    )
}

export default CountAmenityGroup